import Hero from "../components/hero";
import whyChooseHero from "@assets/images/why-choose-gasis-hero.svg";
import sustainabilityHero from "@assets/images/sustainability-hero.svg";
import careersHero from "@assets/images/Group-1410087750.svg";
import newsHero from "@assets/images/news-hero.svg";
import contactHero from "@assets/images/Group-1410087705.svg";
import {
  WhyChooseGasisPage,
  SustainabilityPage,
  CareersPage,
  NewsUpdatesPage,
  ContactPage,
} from "@features/general";

export function BusinessWhyChooseGasis() {
  return (
    <WhyChooseGasisPage
      hero={
        <Hero
          data={{
            title:
              "Your Trusted Partner for Safe, Reliable & Smart Gas Solutions.",
            description:
              "At Gas Integrated Solutions L.L.C. (GASIS), we combine advanced technology, strict safety standards, and exceptional customer service to deliver seamless gas supply and billing solutions across the UAE.",
            image: whyChooseHero,
            footerText:
              "Supported by real-time billing, 24/7 emergency response, and secure infrastructure.",
            footerButtonText: "Talk to Our Team",
          }}
        />
      }
    />
  );
}

export function BusinessSustainability() {
  return (
    <SustainabilityPage
      hero={
        <Hero
          data={{
            title: "Cleaner Energy. Safer Operations. Sustainable Tomorrow.",
            description:
              "At GASIS, sustainability is embedded in everything we do — from smart metering and emissions reduction to safety excellence and community engagement.",
            image: sustainabilityHero,
            footerText:
              "Learn more about our sustainability initiatives or get in touch with our team.",
            footerButtonText: "Contact Sustainability Team",
          }}
        />
      }
    />
  );
}

export function BusinessCareers() {
  return (
    <CareersPage
      hero={
        <Hero
          data={{
            title: "Join a Company That Powers Safety, Innovation & Community",
            description:
              "At Gas Integrated Solutions L.L.C. (GASIS), our people are the foundation of our success. We are committed to hiring skilled professionals who share our values of safety, integrity, innovation, and customer service excellence.",
            image: careersHero,
            buttonText: "View Open Positions",
            buttonOnclick: () => {
              document
                .getElementById("job-openings")
                ?.scrollIntoView({ behavior: "smooth" });
            },
          }}
        />
      }
    />
  );
}

export function BusinessNewsUpdates() {
  return (
    <NewsUpdatesPage
      hero={
        <Hero
          data={{
            title: "Latest News, Safety Alerts & Company Updates",
            description:
              "Stay informed about new services, tariff updates, safety announcements, community programs, and company developments from Gas Integrated Solutions L.L.C. (GASIS).",
            image: newsHero,
            footerText:
              "Subscribe to our newsletter for the latest updates and announcements.",
            footerButtonText: "Subscribe Now",
          }}
        />
      }
    />
  );
}

export function BusinessContact() {
  return (
    <ContactPage
      hero={
        <Hero
          data={{
            title: "We're Always Here for You",
            description:
              "Whether you need help with your bill, want to apply for a new connection, or simply have a question about your gas supply — Gas Integrated Solutions L.L.C. (GASIS) is here 24 hours a day to support you.",
            image: contactHero,
            footerText:
              "Call our 24/7 Emergency Line: 800-GASIS (42747) or report a concern online.",
            footerButtonText: "Report an Emergency",
          }}
        />
      }
    />
  );
}
